<template>
    <comp-9-art-adherence :section="9" :page="46" :next="nextScreen" :nextDisabled="nextDisabled">
        <p class="caption font-weight-bold mb-1 input-label">
            What type of ART have you taken most recently?
        </p>
        <v-radio-group v-model="artTypeSelection" column>
            <v-radio v-for="type in artTypes" :key="type.id" :label="type.text" :value="type"></v-radio>
        </v-radio-group>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artTypeSelection: null
        };
    },
    computed: {
        artType() {
            let selectedArtType = find(this.artTypes, 'selected');

            if (selectedArtType) {
                return selectedArtType;
            } else return null;
        },
        artTypes: sync('section9/artTypes'),
        nextScreen() {
            if (this.artTypeSelection) {
                return `/page/9/${this.artTypeSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.artTypeSelection;
        }
    },
    watch: {
        artTypeSelection(newArtTypeSelection) {
            forEach(this.artTypes, o => {
                if (o.id === newArtTypeSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.artTypeSelection = this.artType;
    }
};
</script>
